// @ts-check
import React, { Component } from 'react';
import { reduxForm } from 'utils/reduxFormWrapper';
import { InjectedFormProps } from 'redux-form'; // eslint-disable-line no-unused-vars
import { TextField } from 'shared/containers/portal_layout/HForm';
import SpinnerButton from 'shared/components/SpinnerButton';
import { required, isLength } from 'utils/validation';
import Errors from 'shared/components/Errors';

const isNpiLength = isLength(10);

/** @typedef {{
  firstName: string,
  lastName: string,
  npi: string
}} CreateProviderFormData */

/** @typedef {{
  createProvider: (formValues: CreateProviderFormData) => Promise,
  onSuccess: () => void
} & InjectedFormProps<CreateProviderFormData>} CreateProviderFormProps */

/** @augments { Component<CreateProviderFormProps> } */
class _CreateProviderForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(formValues) {
    const { createProvider, onSuccess } = this.props;
    return createProvider(formValues).then(onSuccess);
  }

  render() {
    const { handleSubmit, error, submitting, pristine } = this.props;
    return (
      <div className="modal-card" style={{ maxHeight: 99999, margin: 0 }}>
        <form className="form-horizontal" onSubmit={handleSubmit(this.submit)}>
          <header className="modal-card-head">
            <p className="modal-card-title">Enter Referring Provider</p>
            <button className="delete" aria-label="close" />
          </header>
          <section className="modal-card-body">
            <p style={{ marginBottom: '1rem' }}>
              If you couldn't find the referring provider in the search dropdown, you can enter
              him/her here. After entering, the provider will be available in the search dropdown
              for future referrals.
            </p>
            <Errors errors={error || []} />

            <TextField
              id="referringProviderFirstName"
              name="firstName"
              label="Referring Provider First Name"
              validate={required}
            />

            <TextField
              id="referringProviderLastName"
              name="lastName"
              label="Referring Provider Last Name"
              validate={required}
            />

            <TextField
              id="referringProviderNpi"
              name="npi"
              label="Referring Provider NPI"
              validate={[required, isNpiLength]}
            />
          </section>
          <footer className="modal-card-foot">
            <SpinnerButton
              type="submit"
              className="button is-primary is-medium"
              loading={submitting}
              disabled={submitting || pristine}
            >
              Enter Provider
            </SpinnerButton>
          </footer>
        </form>
      </div>
    );
  }
}

const CreateProviderForm = reduxForm({
  form: 'createProviderForm',
})(_CreateProviderForm);

export { CreateProviderForm };
